import { render, staticRenderFns } from "./iconFire.vue?vue&type=template&id=faf15958"
import script from "./iconFire.vue?vue&type=script&lang=js"
export * from "./iconFire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports